import styled, { keyframes, css } from 'styled-components';
import { Modal } from 'antd';
// Abstracts
import * as palette from '../../styles/variables';
import { GO_CREATE_UI_DESIGN } from '../../utils/helper';

const slideInDown = keyframes`
0% { clip-path: inset(0 0% 60% 0); }
50% { clip-path: inset(0 0% 0% 0); }
100% { clip-path: inset(0); }
`;

const fadeText = keyframes` 
   from {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
   }
   to {
     opacity: 1;
     transform: none;
   }
 `;
const imageIn = keyframes` 
  from {
    right:20px;
    transform: scale(1.3);
  }
  to {
    right:0px;
    transform: scale(1.2);
  }
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;
export const ScrollContainer = styled.div`
  overflow: hidden;
  overflow-y: ${props => !props.uploadCurrent && 'overlay'};
  width: 95%;
  margin: ${props => props.table && 'auto'};
  padding-right: ${props => props.table && '10px'};
  margin-left: ${props => props.table ? '' : "5%"};
  height:${props => !props.table && "100vh"};
  max-height:${props => props.table && "50rem"}
  background: ${props => props.isUploadFile ? '#f5f6f9 !important' : props.table ? "" : palette.WHITE_COLOR} ;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 8px !important;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  ::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: transparent !important;
    border-radius: 10px;
    background: rgba(222, 222, 222, 0.6);
  }
  ::-webkit-scrollbar-thumb:hover {
    border-radius: 10px;
    -webkit-box-shadow: transparent !important;
    background-color: #3bcabd;
  }
  &.on-scrollbar::-webkit-scrollbar-track {
    -webkit-box-shadow: transparent !important;
    border-radius: 10px;
    background: rgba(222, 222, 222, 0.6);
  }

  &.on-scrollbar::-webkit-scrollbar {
    width: 8px;
  }

  &.on-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: transparent !important;
    background-color: #3bcabd;
  }

  @media only screen and (max-width: 425px) {
    margin-top: 65px;
    margin-left: 0 !important;
    height: 97vh;
    width: 100%;
    margin-left: 0;
  }
  .anticon.anticon-arrow-up {
    position: absolute;
    bottom: 80px;
    right: 0;
    background: rgb(37, 41, 45);
    color: #fff;
    padding: 15px;
    font-size: 20px;
    @media only screen and (min-width: 1460px) {
      font-size: 25px;
    }
  }
`;

export const HeroContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: ${palette.WHITE_COLOR};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    height: 110vh;
    bottom: -15px !important;
    right: 20px !important;
    transform: scale(1.2);
    transform-origin: center center;
    animation: ${imageIn} 2s ease-in-out;
    @media only screen and (max-width: 425px) {
      width: 600px;
      right: -50px !important;
      height: 100vh;
    }
    @media only screen and (max-width: 320px) {
      width: 600px;
      right: -85px !important;
      height: 100vh;
    }
  }
  ${GO_CREATE_UI_DESIGN && css`
    img {
      top: 50%;
      right: 0 !important;
      bottom: auto;
      transform: translateY(-50%);
      height: auto;
      width: 30%;
      animation: none;
    }
  `};
`;

export const HeroGrid = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  svg {
    margin-left: 100px !important;
  }
  @media only screen and (min-width: 1450px) {
    svg {
      margin-left: 140px !important;
    }
  }
  @media only screen and (min-width: 2560px) {
    svg {
      margin-left: 0px !important;
    }
  }
  .hero-grid-item {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    z-index: 10;
    img {
      max-width: 330px;
    }

    &:first-child {
      width: 100%;
      @media only screen and (min-width: 2560px) {
        width: 75%;
      }
    }
  }
  .app_button {
    overflow: hidden;
    @media only screen and (min-width: 2560px) {
      height: 100px;
    }
    @media only screen and (max-width: 425px) {
      margin-right: 23%;
    }
  }
  ${GO_CREATE_UI_DESIGN && css`
    .hero-grid-item {
      div:first-child {
        margin-bottom: 0px;
      }
    }
    h3 {
      font-weight: 700;
    }
    *:not(.app_button *) {
      color: ${palette.GC_PRIMARY_COLOR};
      font-family: ${palette.GC_FONT_FAMILY} !important;
    }
    .app_button button {
      height: 48px;
      padding-inline: 28px;
      font-size: 16px;
      background: ${palette.GC_PRIMARY_COLOR};
      color: #fff !important;
    }
  `};
`;
export const ApplicationTitle = styled.div`
  width: 100%;
  text-align: center;
  font-size: 50px;
  height: 90px;
  overflow: hidden;
  font-weight: 500;
  color: #000;
  padding: 20px;
  font-family: ${palette.FONT_FAMILY_LANDPAGE};
  letter-spacing: -1.2px;
  word-spacing: 10px;
  line-height: 1.3;
  margin-bottom: 20px;
  .hero_text {
    animation-delay: 1s;
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  }
  @media only screen and (min-width: 2560px) {
    font-size: 100px;
    height: 150px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 32px;
    height: 80px;
  }
  @media only screen and (max-width: 425px) {
    font-size: 25px;
    height: 85px;
    width: 75%;
    margin-right: 28%;
  }
`;

export const GetStarted = styled.div`
  button:hover {
    cursor: pointer;
  }
  button {
    position: relative;
    overflow: hidden;
    font-size: 11.4px;
    font-weight: 700 !important;
    letter-spacing: 1px;
    font-family: ${palette.FONT_FAMILY_LANDPAGE} !important;
    line-height: 1.3;
    height: 40px;
    width: fit-content;
    min-width: 180px;
    text-transform: uppercase;
    border-radius: 64px;
    background-color: ${palette.APP_BRAND_YELLOW_COLOR};
    border: ${palette.APP_BRAND_YELLOW_COLOR};
    animation: ${fadeText} 1s ease-in-out 0s forwards;
    color: #000;
    z-index: 1;
    @media only screen and (min-width: 2560px) {
      font-size: 22px;
      height: 85px;
      letter-spacing: 1.5px;
      width: 380px;
    }
    .anticon {
      svg {
        margin: 0 !important;
      }
    }
  }
  button:hover:before {
    opacity: 1;
    transform: translate(0, 0);
  }
  button:before {
    content: attr(data-hover);
    position: absolute;
    left: 0;
    width: 100%;
    text-transform: uppercase;
    opacity: 0;
    transform: translate(0, 100%);
    transition: all 0.2s ease-in-out;
  }
  button:hover div {
    opacity: 0;
    transform: translate(0, -100%);
  }
  button div {
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
  }
`;

export const ApplicationHelpText = styled.h3`
  width: 100%;
  height: 70px;
  font-family: 'Sacramento', cursive;
  font-size: 45px;
  font-weight: 500;
  margin-bottom: 30px;
  line-height: 1.5;
  text-align: center;
  color: #000;
  overflow: hidden;
  .hero_text {
    animation-delay: 1s;
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  }
  @media only screen and (min-width: 2560px) {
    font-size: 80px;
    height: 120px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 38px;
    height: 60px;
  }
  @media only screen and (max-width: 425px) {
    font-size: 22px;
    height: 35px;
    width: 75%;
    margin-right: 28%;
  }
`;

const displayFlex = css`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const NavGridContainer = styled.div`
  justify-content: center;
  padding: 15px;
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  ${displayFlex};

  .patnerLogo {
   position: absolute;
   bottom: 20%;
  ${displayFlex}
 } 
  .logo_1 {
    padding-bottom: 45px; 
    width: 70%;
   }
  .logo {
     color: white;
     transform: rotate(270deg);
   };  
  @media only screen and (max-width: 420px) {
  .logo_1 {
    width: 10%;
    padding-bottom: 0px;
  }  
  .logo{
     transform: rotate(0deg);
     width: 10%;
  }
  .patnerLogo{
    ${displayFlex};
     flex-direction: row;
     justify-content: end;
     right: 32%;
     bottom:unset;
     gap: 10px;
  }     
}
}
`;
export const TopNavContainer = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  left: 0;
  width: 5%;
  height: 100%;
  transition: color 0.5s, background-color 0.5s;
  background-color: #18012f;
  &::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: '';
    transition: opacity 0.3s;
    opacity: 1;
  }
  @media only screen and (max-width: 425px) {
    height: 85px;
    width: 100%;
  }

  @media only screen and (min-width: 2560px) {
    width: 150px;
  }
  ${GO_CREATE_UI_DESIGN && css`
    background: ${palette.GC_PRIMARY_COLOR};
  `};
`;

export const GridItemContainer = styled.div`
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  a {
    text-decoration: none !important;
  }

  @media only screen and (max-width: 425px){
    display: flex;
    flex-direction:row;
    align-items: center;
    justify-content: space-between;
    height:50px;
    width:100%;
  }

  .header__burger {
    display: flex;
    align-items:center;
    justify-content:center;
    position: relative;
    width: 40px;
    height: 38px;
    vertical-align: middle;
    cursor: pointer;
    pointer-events: initial;
    z-index: 500;
    @media only screen and (max-width: 425px){
      margin:0px;
      width: 30px;
      height: 35px;
    }
  }
  
  .header__burger:hover .header__burger-line:nth-of-type(1) {
    transform: scaleX(1);
  }
  
  .header__burger:hover .header__burger-line:nth-of-type(2) {
    transform: scaleX(0.75);
  }
  
  .header__burger:hover .header__burger-line:nth-of-type(3) {
    transform: scaleX(1);
  }
  
   .header__burger-line {
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #fff;
    color: #fff;
    transition: all 0.2s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  }
  .header__burger-line:nth-of-type(1) {
    top: 9px;
    left: 0;
    transform-origin: right center;
    transform: scaleX(0.75);
  }
  
  .header__burger-line:nth-of-type(2) {
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    transform-origin: left center;
  }
  
  .header__burger-line:nth-of-type(3) {
    bottom: 9px;
    left: 0;
    transform-origin: right center;
    transform: scaleX(0.75);
  }
.opended{
.header__burger-line:nth-of-type(1), .header__burger:hover .header__burger-line:nth-of-type(1) {
    transform: scaleX(1) rotate(45deg) translate(10px, 15px);
  }
 .header__burger-line:nth-of-type(2), .header__burger:hover .header__burger-line:nth-of-type(2) {
    transform: scaleX(0);
  }
 .header__burger-line:nth-of-type(3), .header__burger:hover .header__burger-line:nth-of-type(3) {
    transform: scaleX(1) rotate(-45deg) translate(17px, -23px);
  }
  @media only screen and (max-width: 425px){
    .header__burger-line:nth-of-type(1), .header__burger:hover .header__burger-line:nth-of-type(1) {
      transform: scaleX(1) rotate(45deg) translate(11px, 15px);
    }
    .header__burger-line:nth-of-type(3), .header__burger:hover .header__burger-line:nth-of-type(3) {
      transform:scaleX(1) rotate(-45deg) translate(10px,-16px)
    }
  }
}
.copy_right{
  flex-direction:column;
    font-size: 12px;
    line-height: 1.3;
    color: #fff;
    font-weight: 200;
    @media only screen and (min-width: 768px) {
      writing-mode: vertical-rl;
      text-orientation: sideways-right;
      transform: rotate(180deg);
    }
    @media only screen and (min-width: 2560px) {
      font-size: 22px;
    }
}
@media only screen and (min-width: 2560px) {
  .header__burger {
    width: 70px;
    height: 50px;
  }
   .header__burger-line {
    height: 3px;
  }
  .opended{
    .header__burger-line:nth-of-type(1), .header__burger:hover .header__burger-line:nth-of-type(1) {
        transform:scaleX(1) rotate(45deg) translate(30px,40px)
      }
      .header__burger-line:nth-of-type(3), .header__burger:hover .header__burger-line:nth-of-type(3) {
        transform: scaleX(1) rotate(-45deg) translate(15px, -27px);
      }
}
`;

export const AppLogo = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg{
    width:34px;
    transform: rotate(-35deg);
  }
  img{    
    width:90%;
    margin-top: -20px;
  @media only screen and (min-width: 2560px) {
     svg{
      width:80px;
    }
    img{    
      width:100%;
      margin-top: -20px;
    }
  }
  @media only screen and (max-width: 425px){
    display:flex;
    flex-direction:row;
    svg{
      width:35px;
    }
    img{    
      width: 35px;
      margin-left: 80px;
      margin-top: 0px;
      transform: rotate(90deg);
    }
  
  }
  img{    
    width:90%;
    margin-top: -20px;
  }
  @media only screen and (min-width: 2560px) {
     svg{
      width:80px;
    }
    img{    
      width:100%;
      margin-top: -20px;
    }
  }
  @media only screen and (max-width: 425px){
    display:flex;
    flex-direction:row;
    svg{
      width:35px;
    }
    img{    
      width: 35px;
      margin-left: 80px;
      margin-top: 0px;
      transform: rotate(90deg);
    }
  
  }
`;

export const ModalBody = styled.div`
  background: transparent;
`;
export const DesignModal = styled(Modal)`
  .design_form {
    overflow: hidden;
  }
  .ant-modal-content {
    animation: ${props => !props.categ && slideInDown} 2s ease-in-out !important;
  }
  .ant-modal-body {
    overflow: hidden;
  }
  p {
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
    white-space: normal;
    text-align: center;
  }
  .ant-modal-content {
    box-shadow: none !important;
  }
  .ant-modal-title {
    font-size: 18px !important;
    font-family: 'Open Sans', sans-serif;
    font-weight: 100 !important;
    text-transform: uppercase;
  }
  .ant-radio {
    margin-bottom: 10px;
  }
  .ant-radio-inner {
    width: 20px;
    height: 20px;
    border-color: transparent;
    background: transparent;
  }
  .ant-radio-wrapper {
    height: 100px;
    width: 150px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 2%;
    margin: 3%;
    box-shadow: rgb(50 50 93 / 25%) 0px 50px 100px -20px, rgb(0 0 0 / 30%) 0px 30px 60px -30px;
  }
  .document.ant-radio-wrapper {
    background: #480a74;
    p {
      color: #fff !important;
    }
    .ant-radio-checked .ant-radio-inner {
      border-color: transparent !important;
      background: #ffec3c !important;
    }
    .ant-radio-inner::after {
      color: #000;
    }
  }
  .short-message.ant-radio-wrapper{
    background:#479D9E !important;
    color:#fff;
    .ant-radio-checked .ant-radio-inner {
      border-color:transparent !important;
      background:#1632A6 !important;
    }  
    .ant-radio-inner::after {
      color:#fff;
    }
  }
  .email.ant-radio-wrapper {
    background: #ffec3c !important;
    .ant-radio-checked .ant-radio-inner {
      border-color: transparent !important;
      background: #480a74 !important;
    }
    .ant-radio-inner::after {
      color: #fff;
    }
  }
  .document.ant-radio-wrapper.ant-radio-wrapper-checked {
    display: flex;
    justify-content: center;
    padding: 0 !important;
  }
  .email.ant-radio-wrapper.ant-radio-wrapper-checked {
    display: flex;
    justify-content: center;
    padding: 0 !important;
  }
  .ant-radio-group {
    display: flex;
    margin-top: 20px;
  }
  .selection-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
  .ant-radio-inner::after {
    position: absolute;
    top: 10%;
    left: 10%;
    background: transparent;
    font-size: 15px;
    font-weight: bold;
    border-top: 0;
    border-left: 0;
    border-radius: 8px;
    content: '✓';
  }
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: transparent !important;
  }

  .fade-enter .design_input {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-enter-active .design_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit .design_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit-active .design_input {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-enter-active .design_input,
  .fade-exit-active .design_input {
    transition: opacity 500ms, transform 500ms;
  }
  @media only screen and (min-width: 2560px) {
    .ant-radio-wrapper {
      height: 125px;
    }
  }
  .ant-checkbox-group {
    padding: 10px;
  }
  .ant-checkbox-group-item {
    margin: 5px;
  }
  .ant-checkbox + span {
    padding-right: 8px;
    padding-left: 8px;
    font-family: Raleway, sans-serif;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    fill: #585858;
    color: #d8d6d6;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 0px 0px 0px 0px;
    @media only screen and (min-width: 1460px) {
      font-size: 12px;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: linear-gradient(to right, #ef9d43, #e75516);
    border-color: rgb(219, 57, 31);
    border: 2px solid rgb(219, 57, 31) !important;
  }
  .ant-checkbox-checked::after {
    border-color: rgb(219, 57, 31);
    border: 1px solid rgb(219, 57, 31);
  }
  .badge {
    font-size: 13px;
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgb(219, 57, 31) !important;
    margin-left: 10px;
    @media only screen and (max-width: 1460px) {
      font-size: 11px;
      height: 22px;
      width: 22px;
    }
  }
  ${GO_CREATE_UI_DESIGN && css`
    .document.ant-radio-wrapper {
      background: ${palette.GC_DOCUMENT_OPTION_BACKGROUND_COLOR};
    }
    .email.ant-radio-wrapper {
      background: ${palette.GC_EMAIL_OPTION_BACKGROUND_COLOR} !important;
      color: #fff;
    }
    .short-message.ant-radio-wrapper {
      background: ${palette.GC_SHORT_MESSAGE_OPTION_BACKGROUND_COLOR} !important;
    }
  `};
`;

export const MenuDrawer = styled.div`
  position: ${props => (props.SearchDrawer ? 'fixed' : 'absolute')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 100%;
  right: ${props => props.SearchDrawer && '0'};
  z-index: 200;
  top: 0;
  width: 25vw;
  height: 100vh;

  @media only screen and (max-width: 465px) {
    top: 85px;
    margin-left: 0;
    width: 100vw;
    height: 100vh;
  }
  .menus {
    align-items: flex-start;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  @media only screen and (min-width: 1460px) {
    width: ${props => (props.SearchDrawer ? '24vw' : '26vw')};
    height: 100vh;
  }
  p,
  .option,
  .subMenuOption {
    font-size: 20px;
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    line-height: 2;
    text-transform: uppercase;
    @media only screen and (min-width: 1460px) {
      font-size: 26px;
    }
    @media only screen and (min-width: 2560px) {
      font-size: 35px;
    }
    @media only screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
  .subMenuOption {
    font-size: 1.5vw;
    color: #000;
    font-weight: 600;
    white-space: nowrap;
  }
  .subMenuOption:hover {
    color: #26024b;
  }
  .Description {
    text-transform: none;
    font-size: 1vw;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: 12px;
    cursor: default;
  }
  .Description:last-child {
    margin-bottom: 0;
  }
  &.drawVisible {
    .option,
    .subMenuOption,
    .Description {
      position: relative;
      opacity: 0;
      font-family: 'Open Sans', sans-serif;
      -webkit-animation: ${fadeText} 1s ease-in-out 0s forwards;
      animation: ${fadeText} 1s ease-in-out 0s forwards;
      display: flex;
      flex-direction: row;
      align-items: center;
      -webkit-animation-delay: 0.1s;
      animation-delay: 0.1s;
    }
    .subMenuOption {
      animation: drop 0.3s forwards;
    }
    .Description {
      animation: drop 0.3s forwards;
    }
    .subMenuOption:nth-child(4) {
      animation-delay: 0.2s;
    }
    .subMenuOption:nth-child(6) {
      animation-delay: 0.4s;
    }
    .subMenuOption:nth-child(8) {
      animation-delay: 0.6s;
    }
    .subMenuOption:nth-child(10) {
      animation-delay: 0.8s;
    }
    .Description:nth-child(3) {
      animation-delay: 0.1s;
    }
    .Description:nth-child(5) {
      animation-delay: 0.3s;
    }
    .Description:nth-child(7) {
      animation-delay: 0.5s;
    }
    .Description:nth-child(9) {
      animation-delay: 0.7s;
    }
    .Description:nth-child(11) {
      animation-delay: 0.9s;
    }
    @keyframes drop {
      0% {
        opacity: 0;
        transform: translateY(50px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .option:hover,
    .subMenuOption:hover {
      .arrow {
        background: #000;
        height: 2px;
        width: 16px;
        position: absolute;
        left: 100%;
        cursor: pointer;
        margin-left: 15px;
        transition: 0.2s ease-in-out !important;
        &:before,
        &:after {
          content: '';
          background: #000;
          position: absolute;
          height: 2px;
          width: 12px;
        }

        &:before {
          right: -4px;
          bottom: -4px;
          transform: rotate(-45deg);
        }

        &:after {
          right: -4px;
          top: -4px;
          transform: rotate(45deg);
        }
        @media only screen and (min-width: 1460px) {
          height: 2.5px;
          width: 25px;
        }
        @media only screen and (min-width: 2560px) {
          width: 40px;
          &:before {
            width: 20px;
            right: -6px;
            bottom: -6px;
          }
          &:after {
            width: 20px;
            right: -6px;
            top: -6px;
          }
        }
      }
    }
  }
  &.removeAnimation {
    .subMenuOption,
    .Description {
      -webkit-animation: none;
      animation: none;
    }
  }
  &.drawInVisible {
    visibility: hidden;
  }
  .switch_test + .box {
    opacity: 1;
    right: 0%;
  }

  .switch_test + .box::after {
    animation: bounce-color steps(1) 1s 1, bounce-size linear 1s 1;
  }

  .box {
    display: flex;
    justify-content: center;
    // width:25vw;
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    padding: 24px 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 70%;
    opacity: 0;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }

  .box::after {
    content: '';
    position: absolute;
    right: 100%;
    top: 0;
    bottom: 0;
    border-radius: 100%;
  }

  @keyframes bounce-size {
    0% {
      width: 0;
      right: 0;
    }
    10% {
      width: 32%;
      right: -16%;
    }
    20% {
      width: 0;
      right: 0;
    }
    30% {
      width: 16%;
      right: -8%;
    }
    40% {
      width: 0;
      right: 0;
    }
    50% {
      width: 8%;
      right: -4%;
    }
    60% {
      width: 0;
      right: 0;
    }
    70% {
      width: 4%;
      right: -2%;
    }
    80% {
      width: 0;
      right: 0;
    }
    90% {
      width: 2%;
      right: -1%;
    }
    100% {
      width: 0;
      right: 0;
    }
  }
  @keyframes bounce-color {
    0% {
      background-color: #fff;
    }
    20% {
      background-color: ${palette.APP_BRAND_YELLOW_COLOR};
    }
    40% {
      background-color: #fff;
    }
    60% {
      background-color: ${palette.APP_BRAND_YELLOW_COLOR};
    }
    80% {
      background-color: #fff;
    }
    100% {
      background-color: ${palette.APP_BRAND_YELLOW_COLOR};
    }
    ${GO_CREATE_UI_DESIGN && css`
      20%, 60%, 100% {
        background: ${palette.GC_PRIMARY_COLOR};
      } 
    `};
  }

  .switch_searchBar + .searchDrawer {
    opacity: 1;
    left: 0%;
  }

  .switch_searchBar + .searchDrawer::after {
    -webkit-animation: bounce-color-search steps(1) 1s 1, bounce-size-search linear 1s 1;
    animation: bounce-color-search steps(1) 1s 1, bounce-size-search linear 1s 1;
  }

  .searchDrawer {
    color: #000;
    background: rgb(37, 41, 45);
    padding: 12px;
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    left: 70%;
    opacity: 0;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }

  .searchDrawer::after {
    content: '';
    position: absolute;
    right: 100%;
    top: 0;
    bottom: 0;
    border-radius: 100%;
  }
  @keyframes bounce-size-search {
    0% {
      width: 0;
      left: 0;
    }
    10% {
      width: 32%;
      left: -16%;
    }
    20% {
      width: 0;
      left: 0;
    }
    30% {
      width: 16%;
      left: -8%;
    }
    40% {
      width: 0;
      left: 0;
    }
    50% {
      width: 8%;
      left: -4%;
    }
    60% {
      width: 0;
      left: 0;
    }
    70% {
      width: 4%;
      left: -2%;
    }
    80% {
      width: 0;
      left: 0;
    }
    90% {
      width: 2%;
      left: -1%;
    }
    100% {
      width: 0;
      left: 0;
    }
  }
  @keyframes bounce-color-search {
    0% {
      background-color: #fff;
    }
    20% {
      background-color: rgb(37, 41, 45);
    }
    40% {
      background-color: #fff;
    }
    60% {
      background-color: rgb(37, 41, 45);
    }
    80% {
      background-color: #fff;
    }
    100% {
      background-color: rgb(37, 41, 45);
    }
  }

  .SubNav {
    position: relative;
    top: 0;
    left: 25vw;
    width: 25vw;
    background-color: #c9e165;
    padding: 0 12%;
    height: 100vh;
    opacity: 0;
    z-index: -9999;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 12%;
    ::-webkit-scrollbar {
      display: none;
    }
    @media screen and (max-height: 624px) {
      justify-content: flex-start;
      padding: 60px 12%;
    }
    .Layer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background-color: black;
      opacity: 0.1;
    }
    .slide-right {
      left: 25vw;
      transition: 0.2s 0.2s ease-in-out;
    }
    .slide-left {
      left: 0%;
      transition: 0.2s ease-in-out;
    }
  }
  .fade {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }
  .slide-left-delay {
    left: 0%;
    transition: 0.2s 0.1s ease-in-out;
  }
  .initial_avatar {
    height: 64px;
    width: 64px;
    background: ${palette.GC_SECONDARY_COLOR};
    font-size: 28px;
    display: grid;
    place-content: center;
    margin-bottom: 50px;
    border-radius: 50%;
    align-self: flex-start;
    .user_name {
      display: none;
    }
    :hover {
      width: auto;
      display: block;
      background: transparent;
    }
    :hover .initial {
      display: none;
    }
    :hover .user_name {
      display: block;
    }
  }
  ${GO_CREATE_UI_DESIGN && css`
    color: #fff;
    .menus {
      align-items: center;
    }
    &.drawVisible {
      .option,
      .subMenuOption,
      .Description {
        text-align: center;
    }
    .subMenuOption {
      color: #fff;
    }
    .subMenuOption:hover {
      color: #fff;
      font-weight: 700;
    }
    .Description {
      text-align: center;
    }
    &.drawVisible {
      .option:hover,
      .subMenuOption:hover {
        .arrow {
          background: #fff;
          &:before,
          &:after {
            background: #fff;
          }
        }
      }
    }
    .box {
      background: ${palette.GC_PRIMARY_COLOR};
    }
    .SubNav {
      background: ${palette.GC_SECONDARY_COLOR};
    }
  `};
`;

export const TranslateOption = styled.div`
  position: absolute;
  right: 15px;
  bottom: 15px;
  ${GO_CREATE_UI_DESIGN && css`
    * {
      color: #fff;
    }
  `};
`;


export const MenuItem = styled.div`
  font-size: 16px;
  color: #0e1318;
  font-weight: ${props => (props.active ? 'bold' : '')};
  .anticon {
    margin: 0px 0px 0px 15px;
    color: green;
  }
`;

export const DropDownContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .ant-btn.ant-dropdown-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: #000;
    font-size: 16px;
  }
`;

export const UserNameText = styled.div`
position: relative;
height: 60px;
width: 90px;
margin-bottom: 60px;
h2 {
  position: absolute;
  top: 50%;
  font-family: 'Berkshire Swash', cursive;
}
.initial {
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: uppercase;
  opacity: 0;
  animation: ${props => props.isHovered ? 'fadeOpacityOut 0.2s ease forwards' : 'fadeOpacityIn 0.2s 0.2s ease forwards'};
}
.full-name {
  left: 0;
  transform: translateY(-50%);
  opacity: 0;
  animation: ${props => props.isHovered ? 'fadeOpacityIn 0.2s 0.2s ease forwards' : 'fadeOpacityOut 0.2s ease forwards'};
  white-space: wrap;
  width: 16ch;
  overflow: hidden;
  text-overflow: ellipsis;
  }
  @media (max-width: 1400px) {
    h2 {
      font-size: 26px;
    }
  }
  @media (max-width: 1000px) {
    h2 {
      font-size: 22px;
    }
}
@keyframes fadeOpacityIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadeOpacityOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
}
  ul {
    position: absolute;
    &::before, &::after {
      content: '';
      position: absolute;
    }
  }
  ul {
    width: 60px;
    height: 60px;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
`;

  export const ListItem = styled.li`
  position: absolute;
  &::before, &::after {
    content: '';
    position: absolute;
  }
  width: 2px;
  height: 30px;
  left: 50%;
  border-radius: 3px;
  transform-origin: 50% 100%;
  transform: translateX(-50%) rotate(${props => props.rotate}deg);
  &::before, &::after {
    opacity: 0;
    width: 100%;
    height: 50%;
    top: 100%;
    background: black;
    border-radius: 3px;
    animation: ${props => props.drawVisible ? !props.isHovered ? 'anim 0.5s ease-in-out' : 'none' : 'none'};
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
  }
  &::before {
    animation-delay: 0.02s;
  }
  &::after {
    animation-delay: 0.05s;
  }
  @keyframes anim {
  0% {
    top: 100%;
    opacity: 0;
  }
  100% {
    top: -50%;
    opacity: 1;
  }
}
`
export const LoaderScreenStyles = styled(Modal)`
  * {
    font-family: 'Open Sans', sans-serif;
  }
  .ant-modal-body {
    height: 220px;
    padding: 0;
  }
  .ant-modal-content {
    overflow: hidden;
  }
  header {
    height: 20%;
    width: 100%;
    padding: 12px;
    background: #000;
    text-align: center;
    ${props =>
      props.loadingComplete && `
      animation: slide-bottom 0.8s linear forwards;  
    `}
  }
  @keyframes slide-bottom {
    to {
      height: 100%;
    }
  }
  header h2 {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
  }
  main {
    height: 80%;
    padding: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .check-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 15px;
  }
  .list-item {
    display: flex;
  }
  .icon {
    width: 30px;
    color: #8c52ff;
  }
  .completed {
    color: #000;
  }
  .setup-complete {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 18px;
  }
  .setup-complete ft-green-tick {
    transform: scale(0);
    animation: pop-up 0.8s 0.8s linear forwards;
  }
  @keyframes pop-up {
    90% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
  .setup-complete h3 {
    color: #fff;
    font-size: 16px;
    opacity: 0;
    transform: translateY(-30px);
    animation: fade-text-in 0.5s 0.8s linear forwards;
  }
  @keyframes fade-text-in {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .setup-complete .ant-btn {
    border: none;
    border-radius: 6px;
    padding: 4px 24px;
    background: #8c52ff;
    color: #fff;
    font-family: 'Open Sans' !important;
  }
  .setup-complete .ant-btn:active {
    transform: scale(0.95);
  }
  .anticon-close {
    color: #fbfbfb;
    font-size: 16px;
  }
`;